module.exports = __webpack_public_path__ + "static/media/badge.08927475.svg";